import {
  adminEvalsApi,
  adminErrorBucketsApi,
  adminCriticsApi,
  adminBugAcceptanceApi,
  adminAnalysisApi,
  adminAggregatesApi,
  adminProductUsageApi,
} from './services/adminApiBases'
import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import { projectDataApi } from './services/projectDataApi'
import { taskActionsApi } from './services/taskActionsApi'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [projectDataApi.reducerPath]: projectDataApi.reducer,
    [adminEvalsApi.reducerPath]: adminEvalsApi.reducer,
    [adminErrorBucketsApi.reducerPath]: adminErrorBucketsApi.reducer,
    [adminCriticsApi.reducerPath]: adminCriticsApi.reducer,
    [adminBugAcceptanceApi.reducerPath]: adminBugAcceptanceApi.reducer,
    [adminAnalysisApi.reducerPath]: adminAnalysisApi.reducer,
    [adminAggregatesApi.reducerPath]: adminAggregatesApi.reducer,
    [adminProductUsageApi.reducerPath]: adminProductUsageApi.reducer,
    [taskActionsApi.reducerPath]: taskActionsApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
    projectDataApi.middleware,
    adminEvalsApi.middleware,
    adminErrorBucketsApi.middleware,
    adminCriticsApi.middleware,
    adminBugAcceptanceApi.middleware,
    adminAnalysisApi.middleware,
    adminAggregatesApi.middleware,
    adminProductUsageApi.middleware,
    taskActionsApi.middleware,
  ),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
